/*
  REFINED LAYOUT COMPONENT
  Synchronizing isDesktop logic with Sidebar and Header.
*/

import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

import Header from "./Header";
import Sidebar from "./Sidebar";
import Loader from "./Loader";

import { classNames, role_name } from "../../utils";

const Layout = () => {
  const [openMenu, setOpenMenu] = useState(window.innerWidth >= 1024);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      const desktop = window.innerWidth >= 1024;
      setIsDesktop(desktop);
      // Logic: Desktop should defaults to open, Mobile to closed
      setOpenMenu(desktop);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Check if current page is a meeting page
  const isMeetingPage = location.pathname.includes("/meeting");

  return (
    <>
      {["Admin", "Reporting Head", "Credit Manager"].includes(role_name()) &&
      !isMeetingPage ? (
        <div className="min-h-screen bg-gray-50 flex flex-col antialiased">
          {/* header */}

          <Header openMenu={openMenu} setOpenMenu={setOpenMenu} />

          <div className="flex flex-1 relative">
            {/* sidebar */}
            <Sidebar openMenu={openMenu} setOpenMenu={setOpenMenu} />

            {/* main body */}
            <main
              className={classNames(
                "flex-1 p-4 sm:p-6 lg:p-4 transition-all duration-300 ease-in-out bg-aliceBlue min-h-calcHeight",
                isDesktop ? (openMenu ? "lg:ml-72" : "lg:ml-20") : "ml-0",
                "overflow-x-hidden", // Guard against unexpected width leaks
              )}
            >
              <React.Suspense fallback={<Loader />}>
                <div className="w-full">
                  <Outlet />
                </div>
              </React.Suspense>
            </main>
          </div>
        </div>
      ) : (
        <React.Suspense fallback={<Loader />}>
          <Outlet />
        </React.Suspense>
      )}
    </>
  );
};

export default Layout;
